<template>
  <CRow>
    <CCol col="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Programs
          <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Program</CButton>
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CDataTable
            :items="items"
            :fields="fields"
            column-filter
            table-filter
          >
          <!-- <template #show="{item}">
            <td>
              <CButton size="sm" color="primary" @click="show( item.program_id )">Show</CButton>
            </td>
          </template> -->
          <template #allow_blanks="{item}">
            <td>
              {{item.allow_blanks ? 'Yes' : 'No'}}
            </td>
          </template>
          <template #split_by_product_class="{item}">
            <td>
              {{item.split_by_product_class ? 'Yes' : 'No'}}
            </td>
          </template>
          <template #edit="{item}">
            <td>
              <CButton size="sm" color="primary" @click="edit( item )">Edit</CButton>
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
            </td>
          </template> -->
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>

      <CModal
        title="Add Program"
        :show.sync="addModal"
      >
        <CForm v-if="addModal">
          <CInput
            :lazy="false"
            label="Program Name"
            :value.sync="form.program_name"
            placeholder="Program Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Days Out for Shipping"
            type="number"
            :value.sync="form.days_out"
            placeholder="Days Out to Order"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Cost"
            :value.sync="form.cost"
            placeholder="Cost"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Min Qty"
            :value.sync="form.min_quantity"
            placeholder="Min Qty"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div>
            <label>Allow Blanks</label>
            <select class="form-control" v-model="form.allow_blanks">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <CInput
            :lazy="false"
            label="Subtract Quantity (x amount from min quantity)"
            type="number"
            :value.sync="form.subtract_quantity"
            placeholder="Ex 6 units under min quantity"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Upcharge Min Pieces < Min Quantity"
            type="text"
            :value.sync="form.subtract_upcharge"
            placeholder="Ex $1.75 upcharge per under min quantity"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Free Decorations"
            type="number"
            :value.sync="form.free_decorations"
            placeholder="Ex 1"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Min Locations"
            type="number"
            :value.sync="form.min_locations"
            placeholder="Ex 1"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Deduction"
            type="text"
            :value.sync="form.meet_min_quantity_deduction"
            placeholder="Ex 1.50"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>One style per order?</label>
            <div>
              <CButton size="sm" @click="form.one_style_per = 1" :color="form.one_style_per === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.one_style_per = 0" style="margin-left:5px;" :color="form.one_style_per === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Split Order Groups By Product Class?</label>
            <div>
              <CButton size="sm" @click="form.split_by_product_class = 1" :color="form.split_by_product_class === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.split_by_product_class = 0" style="margin-left:5px;" :color="form.split_by_product_class === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="addModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="add()" color="success">Add</CButton>
        </template>
      </CModal>

      <CModal
        title="Edit Program"
        :show.sync="editModal"
      >
        <CForm v-if="editForm">
          <CInput
            :lazy="false"
            label="Program Name"
            :value.sync="editForm.program_name"
            placeholder="Program Name"
            autocomplete="given-name"
            disabled
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Days Out for Shipping"
            type="number"
            :value.sync="editForm.days_out"
            placeholder="Days Out to Order"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div>
            <label>Allow Blanks</label>
            <select class="form-control" v-model="editForm.allow_blanks">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <CInput
            :lazy="false"
            label="Subtract Quantity (x amount from min quantity)"
            type="number"
            :value.sync="editForm.subtract_quantity"
            placeholder="Ex 6 units under min quantity"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Upcharge Min Pieces < Min Quantity"
            type="text"
            :value.sync="editForm.subtract_upcharge"
            placeholder="Ex $1.75 upcharge per under min quantity"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Free Decorations"
            type="number"
            :value.sync="editForm.free_decorations"
            placeholder="Ex 1"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Split Order Groups By Product Class?</label>
            <div>
              <CButton size="sm" @click="editForm.split_by_product_class = 1" :color="editForm.split_by_product_class === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.split_by_product_class = 0" style="margin-left:5px;" :color="editForm.split_by_product_class === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="editModal = false, resetEdit()" color="danger">Cancel</CButton>
          <CButton @click="save()" color="success">Save</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
var methods = {}

methods.getData = function () {
  let self = this
  axios.get( this.$apiAdress + '/api/programs?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.items = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.reset = function () {
  this.form = this.getForm()
}

methods.resetEdit = function () {
  this.editModal = null
}

methods.edit = function (val) {
  // this.editForm = val
  // this.editModal = true
  this.$router.push({ path: '/programs/' + val.program_id + '/edit' })
}

methods.save = function () {
  let self = this
  console.log(this.editForm)
  axios.post(this.$apiAdress + '/api/programs/save?token=' + localStorage.getItem('api_token'), self.editForm)
  .then(function (response) {
    self.editModal = false
    self.resetEdit()
  }).catch(function (error) {
    console.log(error)
  })
}

methods.add = function () {
  let self = this;
  axios.post(   this.$apiAdress + '/api/programs/store?token=' + localStorage.getItem("api_token"),
    self.form
  )
  .then(function (response) {
      console.log(response)
      self.items.push(response.data)
      self.form = self.getForm()
      self.addModal = false
  }).catch(function (error) {
      // if(error.response.data.message == 'The given data was invalid.'){
      //   self.message = '';
      //   for (let key in error.response.data.errors) {
      //     if (error.response.data.errors.hasOwnProperty(key)) {
      //       self.message += error.response.data.errors[key][0] + '  ';
      //     }
      //   }
      //   self.showAlert();
      // }
  });
}

methods.getForm = function () {
  return {
    program_name: '',
    cost: '',
    min_quantity: '',
    days_out: 0,
    allow_blanks: 0,
    subtract_quantity: '',
    subtract_upcharge: '',
    free_decorations: 0,
    min_locations: 1,
    meet_min_quantity_deduction: '',
    one_style_per: 0,
    split_by_product_class: 0
  }
}

export default {
  name: 'Programs',
  data() {
    return {
      items: [],
      fields: ['program_name', 'days_out', 'subtract_quantity', 'subtract_upcharge', 'allow_blanks', 'split_by_product_class', 'free_decorations', 'edit'],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addModal: false,
      form: this.getForm(),
      editForm: null,
      editModal: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    this.getData()
  }
}
</script>
